import { render, staticRenderFns } from "./AreaEmbargadaPa.vue?vue&type=template&id=e4a890ea&scoped=true&lang=pug"
import script from "./AreaEmbargadaPa.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaPa.vue?vue&type=script&lang=js"
import style0 from "./AreaEmbargadaPa.vue?vue&type=style&index=0&id=e4a890ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a890ea",
  null
  
)

export default component.exports